import type { DeliveryMethodType, Product } from '@libs/common-types';
import { DeliveryType } from '@libs/core';
import { resolveFulfillmentMethod } from '@libs/shared-ui';

import { isDeliveryMethodAvailable } from '@/entities/product';
import type { FormFields } from '@/entities/purchase-form';

type ResolveDeliveryMethodParams = {
    purchaseOption: FormFields['purchaseOption'];
    deliveryMethods?: Product['deliveryMethods'];
    selectedDeliveryMethod?: FormFields['fulfilmentMethod'];
};

/**
 * @param params.deliveryMethods - Available delivery methods for the product variant
 * @param params.selectedDeliveryMethod - Currently selected method to preserve when available
 * @returns The resolved delivery method
 */
export function resolveDeliveryMethod({
    purchaseOption,
    deliveryMethods,
    selectedDeliveryMethod,
}: ResolveDeliveryMethodParams): FormFields['fulfilmentMethod'] {
    const availableMethods = {
        bopis: isDeliveryMethodAvailable({
            purchaseOption,
            deliveryMethodName: DeliveryType.BOPIS.toUpperCase() as DeliveryMethodType,
            deliveryMethodData: deliveryMethods?.BOPIS,
        }),
        sdd: isDeliveryMethodAvailable({
            purchaseOption,
            deliveryMethodName: DeliveryType.SDD.toUpperCase() as DeliveryMethodType,
            deliveryMethodData: deliveryMethods?.SDD,
        }),
        sth: isDeliveryMethodAvailable({
            purchaseOption,
            deliveryMethodName: DeliveryType.STH.toUpperCase() as DeliveryMethodType,
            deliveryMethodData: deliveryMethods?.STH,
        }),
    };

    return resolveFulfillmentMethod({ availableMethods, selectedMethod: selectedDeliveryMethod });
}
